export default __webpack_public_path__ + "static/media/cse_455_final_project.bad57217.mp4";